import { IGetClientResModule } from '@msg91/models/root-models';
import { createSelector } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IRootState } from '../reducer/root.reducer';

export const selectState = (state: IAppState) => state;

export const selectRootState = createSelector(selectState, (p) => p.root);

export const selectRootErrors = createSelector(selectRootState, (rootState: IRootState) => rootState.errors);
export const selectTitle = createSelector(selectRootState, (rootState: IRootState) => rootState.headerTitle);

export const selectClients = createSelector(selectRootState, (rootState: IRootState) => rootState.clients);
export const selectClientInProcess = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.clientsInProcess
);
export const selectClientSuccess = createSelector(selectRootState, (rootState: IRootState) => rootState.clientsSuccess);

export const selectSelectedClient = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.selectedClient
);
export const selectSelectedClientCurrency = createSelector(selectSelectedClient, (r: IGetClientResModule) => {
    if (r && r.user_currency) {
        return r.user_currency;
    }
    return null;
});
export const selectSelectedClientIsWalletUser = createSelector(selectSelectedClient, (r: IGetClientResModule) => {
    if (r && r.userWalletEnabled) {
        return +r.userWalletEnabled;
    }
    return null;
});
export const selectSelectedClientUserPid = createSelector(selectSelectedClient, (r: IGetClientResModule) => {
    if (r && r.user_pid) {
        return r.user_pid;
    }
    return null;
});
export const selectShowClientList = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.showClientList
);
export const selectSideBarToggleStatus = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.sideBarToggleStatus
);

export const selectInboundEmailLogPermission = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.inboundEmailLogPermission
);

export const selectEditUserPermission = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.editUserPermission
);

export const selectAccessToken = createSelector(selectRootState, (rootState: IRootState) => rootState?.token);

export const selectDateRange = createSelector(selectRootState, (rootState: IRootState) => rootState?.dateRange);

export const getSelectedWhatsappNumber = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState?.selectedWhatsappNumber
);
export const getAllWhatsAppIntegratedNumbers = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState?.allWhatsAppIntegratedNumbers || []
);
export const getAllWhatsAppActiveNonActiveNumbers = createSelector(selectRootState, (p) => [
    ...p.integratedFbCloudNumbers,
    ...p.integrated360Numbers,
    ...p.integratedHaptikNumbers,
]);

export const loggedInUserRulePermissionStatus = createSelector(selectRootState, (p) => p.userRulePermissionSuccess);

export const getWhatsAppNumberNameMap = createSelector(selectRootState, (p) => p.whatsAppNumberNameMap ?? {});

export const selectAdminMe = createSelector(selectRootState, (rootState: IRootState) => rootState.adminMe);
export const selectAdminMeLoaded = createSelector(selectRootState, (rootState: IRootState) => rootState.adminMeLoaded);
export const selectAdminMeInProcess = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.adminMeInProcess
);
export const selectMicroservicePermissions = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.microservicePermissions
);
export const selectPlatformPermissions = createSelector(
    selectRootState,
    (rootState: IRootState) => rootState.platformPermissions
);

/** True if user has at least one of `anyOf` under microservice/group */
export const selectHasMsPermission = (microservice: string, group: string, anyOf: string[]) =>
    createSelector(selectMicroservicePermissions, (msPermissions) => {
        const perms = msPermissions?.[microservice]?.[group] || [];
        if (!anyOf?.length) {
            return perms.length > 0;
        }
        return anyOf.some((p) => perms.includes(p));
    });
